(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-featured-products"] && !Shopify.designMode) return;
  try {
    
  // This section keeps the native theme product-form behavior.
  // Metafield-based checkbox logic should continue to work through the product-form snippet.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-featured-products-trio"] && !Shopify.designMode) return;
  try {
    
  // Any other JavaScript needed for the trio section can go here

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-bk"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Get all accordion triggers
    const accordionTriggers = document.querySelectorAll('[data-accordion-trigger]');

    // Add click event listener to each trigger
    accordionTriggers.forEach((trigger) => {
      trigger.addEventListener('click', function () {
        // Get the parent accordion element
        const accordion = this.closest('[data-accordion]');

        // Toggle the active class
        accordion.classList.toggle('is-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Get all accordion triggers
    const accordionTriggers = document.querySelectorAll('[data-accordion-trigger]');

    // Add click event listener to each trigger
    accordionTriggers.forEach((trigger) => {
      if (trigger.dataset.accordionInit === '1') return;
      trigger.dataset.accordionInit = '1';
      trigger.addEventListener('click', function () {
        // Get the parent accordion element
        const accordion = this.closest('[data-accordion]');

        // Toggle the active class
        if (accordion) accordion.classList.toggle('is-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
